export const GET_REPORT_DATA_REQUEST = 'GET_REPORT_DATA_REQUEST';
export const GET_REPORT_DATA_SUCCESS = 'GET_REPORT_DATA_SUCCESS';
export const GET_REPORT_DATA_FAILURE = 'GET_REPORT_DATA_FAILURE';

export const getReportDataRequest = (searchParams) => ({
  type: GET_REPORT_DATA_REQUEST,
  payload: { searchParams },
});

export const getReportDataSuccess = (data) => ({
  type: GET_REPORT_DATA_SUCCESS,
  payload: { data },
});

export const getReportDataFailure = (error) => ({
  type: GET_REPORT_DATA_FAILURE,
  payload: { error },
});
